import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import useCooperativeId from 'shared/hooks/useCooperativeId';
import useDispatch from 'shared/hooks/useDispatch';
import {
  changeChatMessage,
  changeBoardMessages,
} from 'store/notifications/slicer';
import { NotificationEntities } from 'utils/enums';

import { EntityName } from '../model/enums';

type UseNotificationUpdateQueryOptions = {
  entityName: EntityName;
};

const useUpdateNotificationQuery = ({
  entityName,
}: UseNotificationUpdateQueryOptions) => {
  const cooperativeId = useCooperativeId();
  const dispatch = useDispatch();
  const location = useLocation();

  const shouldUpdateNotification = useMemo(() => {
    if (!cooperativeId) return false;

    return (
      (entityName as string) === NotificationEntities.EventInformation ||
      (entityName as string) === NotificationEntities.Incident ||
      (entityName as string) === NotificationEntities.Task
    );
  }, [cooperativeId, entityName]);

  const updateNotification = useCallback(() => {
    if (!shouldUpdateNotification) return;

    if (location.pathname.includes('board-eventsinformation')) {
      dispatch(changeBoardMessages(cooperativeId!));
      return;
    }

    dispatch(
      changeChatMessage({
        coopId: cooperativeId as string,
        entities: [entityName as unknown as NotificationEntities],
      })
    );
  }, [cooperativeId, dispatch, entityName, location, shouldUpdateNotification]);

  return updateNotification;
};

export default useUpdateNotificationQuery;
